(() => {
  const header = document.getElementById('siteHeader');
  const updateHeaderHeight = () => {
    document.body.style.setProperty('--mc-catalog-header-height', (header?.getBoundingClientRect().height || 68) + 'px');
  };
  updateHeaderHeight();
  if (header && 'ResizeObserver' in window) new ResizeObserver(updateHeaderHeight).observe(header);
  window.addEventListener('resize', updateHeaderHeight, { passive: true });

  const categoryRail = document.querySelector('.mc-all-categories');
  const selectedCategory = categoryRail?.querySelector('[aria-current="page"]');
  if (selectedCategory && categoryRail.scrollWidth > categoryRail.clientWidth) {
    const selectedBounds = selectedCategory.getBoundingClientRect();
    const railBounds = categoryRail.getBoundingClientRect();
    categoryRail.scrollLeft += selectedBounds.left - railBounds.left - (categoryRail.clientWidth - selectedBounds.width) / 2;
  }

  const cartBar = document.querySelector('[data-shop-cart]');
  let cartRequest = 0;
  const updateCart = async (announce = false) => {
    const request = ++cartRequest;
    try {
      const response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== cartRequest) return;
      const count = document.getElementById('bagCount');
      if (count) count.textContent = cart.item_count;
      if (!cartBar) return;
      cartBar.hidden = cart.item_count === 0;
      cartBar.querySelector('[data-shop-cart-count]').textContent = cart.item_count;
      const total = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency: cart.currency || cartBar.dataset.currency || 'INR',
      }).format(cart.total_price / 100);
      cartBar.querySelector('[data-shop-cart-total]').textContent = total;
      document.body.classList.toggle('mc-shop-has-cart', cart.item_count > 0);
      const status = document.querySelector('[data-shop-cart-status]');
      if (announce && status) status.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in your bag. Total ${total}.`;
    } catch (_) { /* The cart link remains available if the count cannot refresh. */ }
  };
  document.body.classList.toggle('mc-shop-has-cart', Boolean(cartBar && !cartBar.hidden));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => updateCart(true));
  }
  window.addEventListener('pageshow', () => updateCart());
})();
